import { render, staticRenderFns } from "./CargaDescargaList.vue?vue&type=template&id=6894a2f4"
import script from "./CargaDescargaList.vue?vue&type=script&lang=js"
export * from "./CargaDescargaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports